export type CopDocKey =
  | "construction_drawings"
  | "mount_analysis"
  | "rfds"
  | "de_130"
  | "de_111"
  | "final_bom"
  | "checklist";

export interface CopFixedDoc {
  key: CopDocKey;
  label: string;
  required: boolean;
  accept: string; // <input accept="..."> — controls the OS file-picker filter
}

// Common MIME + extension sets for the file picker. Browsers vary in whether
// they report a MIME type or an empty string for .xls/.xlsx, so we list both
// the MIME and the extension.
const PDF_IMG = "application/pdf,image/png,image/jpeg";
const PDF_IMG_DWG = PDF_IMG + ",.dwg";
const EXCEL =
  ".xlsx,.xls," +
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
  "application/vnd.ms-excel";
// DE 130 / DE 111 / BOMs are primarily Excel, but allow PDF fallback
// since these are sometimes shared as a PDF export.
const EXCEL_OR_PDF = EXCEL + ",application/pdf";

export const COP_FIXED_DOCS: CopFixedDoc[] = [
  { key: "construction_drawings", label: "Construction Drawings", required: true,  accept: PDF_IMG_DWG },
  { key: "mount_analysis",        label: "Mount Analysis",        required: true,  accept: PDF_IMG },
  { key: "rfds",                  label: "RFDS",                  required: true,  accept: PDF_IMG },
  { key: "de_130",                label: "Scope",                 required: true,  accept: EXCEL_OR_PDF },
  { key: "final_bom",             label: "Final BOM",             required: true,  accept: EXCEL_OR_PDF },
  // Optional: the Ericsson CRM often doesn't supply the Checklist until the
  // crew is onsite, which would block pre-onsite verification + crew assignment.
  // When it's absent, the backend falls back to the stored default checklist
  // (static/Templates/Default_Checklist.xlsx) so Verify can proceed.
  { key: "checklist",             label: "Checklist",             required: false, accept: EXCEL },
];

// Additional documents can be anything — mirrors the union of all fixed-slot types.
export const COP_ADDITIONAL_ACCEPT = PDF_IMG_DWG + "," + EXCEL;

export const COP_ADDITIONAL_FIELD_KEY = "additional";

export const copDocLabelForKey = (key: string | undefined): string | undefined =>
  COP_FIXED_DOCS.find((d) => d.key === key)?.label;
